"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Wallet = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 18 16",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 0a2 2 0 000 4h13v-.8c0-1.12 0-1.68-.218-2.108a2 2 0 00-.874-.874C13.48 0 12.92 0 11.8 0H2zM0 4v8.8c0 1.12 0 1.68.218 2.108a2 2 0 00.874.874C1.52 16 2.08 16 3.2 16h11.6c1.12 0 1.68 0 2.108-.218a2 2 0 00.874-.874C18 14.48 18 13.92 18 12.8V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 00-.874-.874C16.48 5 15.92 5 14.8 5H2a2.496 2.496 0 01-2-1zm15 6.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zM12.5 12a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
  fill: "#7E8A9A"
}));
var _default = exports.default = Wallet;